export const SetMapInteractable = () => {
  const mapWidget =
    document.querySelectorAll<HTMLElement>(".attrax-map-widget");
  mapWidget.forEach((widget) => {
    widget.addEventListener("click", (e) => {
      if (!widget.classList.contains("attrax-map-widget--interactable")) {
        widget.classList.add("attrax-map-widget--interactable");
      }
    });
  });
};
